var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import io from 'socket.io-client';
import { getWsUrl, isTest } from './utils';
var Mocker = /** @class */ (function () {
    function Mocker() {
        this.events = {};
    }
    Mocker.prototype.on = function (event, cb) {
        this.events[event] = cb;
    };
    Mocker.prototype.trigger = function (event, message) {
        var cb = this.events[event];
        cb === null || cb === void 0 ? void 0 : cb(message);
    };
    return Mocker;
}());
var ImSocketMockServer = /** @class */ (function (_super) {
    __extends(ImSocketMockServer, _super);
    function ImSocketMockServer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.client = null;
        return _this;
    }
    ImSocketMockServer.prototype.connect = function (client) {
        var _this = this;
        this.client = client;
        setTimeout(function () {
            _this.emit('connect', null);
        });
    };
    ImSocketMockServer.prototype.emit = function (event, message) {
        var _a;
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.trigger(event, message);
    };
    return ImSocketMockServer;
}(Mocker));
export { ImSocketMockServer };
var ImSocketMockClient = /** @class */ (function (_super) {
    __extends(ImSocketMockClient, _super);
    function ImSocketMockClient(server) {
        var _this = _super.call(this) || this;
        _this.server = server;
        server.connect(_this);
        return _this;
    }
    ImSocketMockClient.prototype.emit = function (event, message) {
        this.server.trigger(event, message);
    };
    ImSocketMockClient.prototype.close = function () { };
    return ImSocketMockClient;
}(Mocker));
var ImSocket = /** @class */ (function () {
    function ImSocket(isMock) {
        if (isMock === void 0) { isMock = false; }
        this.isMock = false;
        this.connected = false;
        this.mockServer = null;
        this.eventsCaches = [];
        this.connectCb = function () { };
        this.disconnectCb = function () { };
        if (isMock) {
            this.isMock = isMock;
            var mockServer = new ImSocketMockServer();
            this.mockServer = mockServer;
            window.__IM_SOCKET_MOCK_SERVER = mockServer;
        }
        // return this.socket;
    }
    ImSocket.prototype.connect = function (url, cb, options) {
        var _this = this;
        if (cb === void 0) { cb = function () { }; }
        if (options === void 0) { options = {}; }
        this.connectCb = cb;
        if (this.isMock && this.mockServer) {
            this.socket = new ImSocketMockClient(this.mockServer);
        }
        else {
            var wsUrl = getWsUrl(url);
            this.socket = io(wsUrl, options);
        }
        this.socket.on('connect', function () {
            _this.connected = true;
            _this.connectCb();
        });
        this.socket.on('disconnect', function (reason) {
            _this.connected = false;
            _this.disconnectCb();
            if (isTest())
                return;
            console.warn("Ws client has been disconnected, reason: " + reason);
        });
        this.eventsCaches.forEach(function (item) {
            var _a;
            (_a = _this.socket) === null || _a === void 0 ? void 0 : _a.on(item.event, item.cb);
        });
    };
    ImSocket.prototype.close = function (cb) {
        if (cb === void 0) { cb = function () { }; }
        if (!this.connected)
            return;
        if (this.socket === null)
            throw new Error('No socket client found.');
        this.disconnectCb = cb;
        this.socket.close();
        this.connected = false;
    };
    ImSocket.prototype.on = function (event, messageHandler) {
        if (!this.socket) {
            this.eventsCaches.push({ event: event, cb: messageHandler });
            return;
        }
        this.socket.on(event, messageHandler);
    };
    ImSocket.prototype.send = function (event, requestBody) {
        if (!this.socket)
            return;
        this.socket.emit(event, requestBody);
    };
    ImSocket.prototype.getMockServer = function () {
        if (!this.isMock || !this.mockServer)
            return null;
        return this.mockServer;
    };
    ImSocket.prototype.isConnected = function () {
        return this.connected;
    };
    ImSocket.prototype.getSockectInstance = function () {
        return this.socket;
    };
    return ImSocket;
}());
export { ImSocket };
